import { PrefetchService } from '@core/prefetch/prefetch.service';
import { TranslateModifiers } from '@core/translate';
import { Inject } from '@rxdi/core';
import { Component, css, html, LitElement } from '@rxdi/lit-html';
import { Router } from '@rxdi/router';
import { ResponsiveService } from '@rxdi/ui-kit/services';
import { SocialService } from '@stradivario/graphql-server';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

const profilePicture = new URL('./picture.svg', import.meta.url).href;

/**
 * @customElement user-profile-menu
 */
@Component({
  selector: 'user-profile-menu',
  modifiers: [...TranslateModifiers],
  template(this: ProfileMenuComponent) {
    return html`
      <rx-monad>
        <rx-state
          .value=${combineLatest([this.socialService.getUser(), this.responsive.width]).pipe(
            map(([user, width]) => [user, width < 600])
          )}
        ></rx-state>
        <rx-style
          .value=${css`
            .image {
              border-radius: 50%;
              width: 30px;
              height: 30px;
              border: 2px solid var(--menu-profile-border-color, #949494);
            }
          `}
        ></rx-style>
        <rx-render
          .state=${([user, mobile]: [firebase.User, boolean]) => html`
            <dropdown-component
              .marginLeft=${mobile ? '0px' : '-240px'}
              @mouseover=${() => this.prefetch.fetch(import('../profile/profile.module'))}
              @itemClicked=${(event: CustomEvent<'Settings' | 'Logout' | 'Admin' | 'Iot' | 'Payments'>) => {
                if (event.detail === 'Settings') {
                  this.router.go('/profile/settings');
                }
                if (event.detail === 'Logout') {
                  this.socialService.signOut().subscribe(() => this.router.go('/'));
                }
                if (event.detail === 'Admin') {
                  this.router.go('/admin');
                }
                if (event.detail === 'Iot') {
                  this.router.go('/iot');
                }

                if (event.detail === 'Payments') {
                  this.router.go('/payments');
                }
              }}
              .menuItems=${user.email === 'kristiqn.tachev@gmail.com' || user.email === 'p.kolevaa@gmail.com'
                ? ['Iot', 'Admin', 'Settings', 'Logout' /* 'Payments' */]
                : ['Settings', 'Logout' /* 'Payments' */]}
            >
              <div slot="first-item" style="color: black; padding: 15px;    display: grid;">
                <strong
                  >${user && user.displayName && user.displayName.length > 40
                    ? user.displayName.match(/\b(\w)/g).join('')
                    : user.displayName}</strong
                >
                <span style="color: gray">${user.email}</span>
              </div>
              ${user.photoURL
                ? html`
                    <div style="display: flex">
                      <div class="profile-dropdown">
                        <span class="flex: 1 3 auto;"></span>
                        <div>
                          <img class="image" src=${user.photoURL} />
                        </div>
                      </div>
                    </div>
                  `
                : html` <img class="image" src="${profilePicture}" /> `}
            </dropdown-component>
          `}
        ></rx-render>
      </rx-monad>
    `;
  },
})
export class ProfileMenuComponent extends LitElement {
  @Inject(SocialService)
  private socialService: SocialService;

  @Inject(ResponsiveService)
  private responsive: ResponsiveService;

  @Router()
  private router: Router;

  @Inject(PrefetchService)
  public prefetch: PrefetchService;
}
